<!-- PAGE HEADER -->
<div class="mb-5 grid grid-cols-12 bg-gray-50 p-3">
  <div class="col-span-12 border-l-4 border-gray-700 pl-4 lg:col-span-6">
    <div class="grid">
      <p class="text-xs font-medium uppercase tracking-wide text-gray-500">
        Social Posts Section
      </p>

      <h2 class="text-nowrap text-xl font-bold leading-tight text-gray-700">
        Preview
      </h2>
    </div>
  </div>
</div>

<!-- PAGE CONTENT -->
<div class="grid grid-cols-1 gap-6 xl:grid-cols-12" id="grid">

  <!-- MAIN PREVIEW COLUMN -->
  <div class="col-span-12 px-3 2xl:col-span-9 2xl:pr-0">
    <div class="w-full rounded-2xl border border-gray-200 bg-white p-3">

      <!-- NESTED GRID -->
      <div class="grid grid-cols-12 items-start gap-4">

        <!-- LEFT BUTTONS -->
        <div class="hidden flex-col items-center md:flex md:col-span-1">

          <span class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="viewList()"
              [matTooltip]="returnPage ? 'Back' : 'Done'">
              <mat-icon>{{ returnPage ? 'arrow_back' : 'done_outline' }}</mat-icon>
            </button>
          </span>

          <span *ngIf="enableEdit === 1" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="editPost(id)"
              [disabled]="isEditDisabled"
              matTooltip="Edit">
              <mat-icon>edit</mat-icon>
            </button>
          </span>

          <span *ngIf="enableReuse === 1" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="reusePost()"
              [disabled]="isReuseDisabled"
              matTooltip="Reuse">
              <mat-icon>replay</mat-icon>
            </button>
          </span>

          <span *ngIf="enableDelete === 1" class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="openDeleteConfirm()"
              [disabled]="isDeleteDisabled"
              matTooltip="Delete"
              matTooltipPosition="left">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>

          <div class="my-4"></div>

          <span class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="prevPost()"
              [disabled]="prevId === null"
              matTooltip="Previous"
              [matTooltipDisabled]="prevId === null">
              <mat-icon>skip_previous</mat-icon>
            </button>
          </span>

          <span class="block">
            <button
              mat-icon-button
              class="manage-post-btn my-2"
              (click)="nextPost()"
              [disabled]="nextId === null"
              matTooltip="Next"
              [matTooltipDisabled]="nextId === null">
              <mat-icon>skip_next</mat-icon>
            </button>
          </span>

        </div>

        <!-- PREVIEW -->
        <div class="col-span-12 overflow-hidden md:col-span-11">
          <ng-container *ngIf="renderPreview">

            <app-facebook-post
              *ngIf="tag=='photolink' || tag=='fbphotopost' || tag=='fbvideo' || tag=='fbfirstcomment'|| tag=='fbreel'">
            </app-facebook-post>

            <app-facebook-story
              *ngIf="tag=='fbstoryphoto' || tag=='igstoryphoto' || tag=='igstoryvideo'|| tag=='igstoryreel'|| tag=='fbstoryreel'">
            </app-facebook-story>

            <app-instagram-post
              *ngIf="tag=='igphotopost' || tag=='igvideo' || tag=='igcarousel'|| tag=='igreel'">
            </app-instagram-post>

          </ng-container>
        </div>

      </div>

    </div>
  </div>

  <!-- SIDEBAR -->
  <div
    class="hidden md:block col-span-12 px-3 2xl:col-span-3 2xl:px-6"
    *ngIf="posts.length > 0 || alerts.length > 0">

    <div class="grid grid-cols-1 gap-5">

      <app-latest-posts
        [posts]="posts"
        [maxSidebarCards]="maxSidebarCards"
        [naPlaceholder]="naPlaceholder"
        (viewPost)="viewRow($event)">
      </app-latest-posts>

      <app-latest-alerts
        [alerts]="alerts"
        [maxSidebarCards]="maxSidebarCards"
        [naPlaceholder]="naPlaceholder"
        (viewAlert)="viewAlert($event)">
      </app-latest-alerts>

    </div>

  </div>

</div>